var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(("display: block; object-fit: contain; height: " + _vm.computedSize + "px; width: " + _vm.computedSize + "px;")),attrs:{"src":_vm.url},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }